import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import _ from 'lodash';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ContainerReport from '../../../ContainerReport';
import iconData from '../../../../../../assets/images/data.svg';
import { getBotAttendanceTimeGraphic } from '../../../../../../store/actions/reports';
import {
  getFilterPeriodType,
  updateChartXCategories,
  getTotalGraphic,
} from '../../graphic-report-helper';

const CHART_INITIAL_STATE = {
  chart: {
    type: 'column',
    width: 850,
    height: 250,
    style: {
      fontFamily: 'Fira Sans',
    },
  },

  title: {
    text: '',
  },

  xAxis: {
    categories: [],
  },

  yAxis: {
    type: 'linear',
    allowDecimals: false,
    min: 0,
    title: {
      text: '',
    },
    labels: {
      formatter() {
        const dateFormatted = Math.round(this.value / 1000);
        return `${dateFormatted} seg`;
      },
    },
  },

  tooltip: {
    useHTML: true,
    opacity: 1,
    backgroundColor: '#2B323D',
    borderColor: '#2B323D',
    borderRadius: 10,

    formatter() {
      if (this.y <= 0) {
        return false;
      }

      const dateFormatted = Math.round(this.y / 1000);

      return (
        `<table style="color: white;"><tr><td style="text-align: center;">${this.x}</td></tr><tr><td style="text-align: center; color: white;">${dateFormatted} seg` +
        `</td></tr><tr><td style="text-align: center; color: white;">${this.series.name}</td></tr></table>`
      );
    },
  },

  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    align: 'left',
    x: 20,
  },
  series: [
    {
      name: 'Bot',
      serieType: 'bot',
      data: [],
      stack: 'male',
      color: '#f78e43',
    },
    {
      name: 'Humano',
      serieType: 'human',
      data: [],
      stack: 'male',
      color: '#29d6b0',
    },
    {
      name: 'Fila',
      serieType: 'queue',
      data: [],
      stack: 'male',
      color: '#1ea9ec',
    },
  ],
  exporting: {
    enabled: false,
  },
};

const seriesHuman = { ...CHART_INITIAL_STATE.series[1] };
const seriesQueue = { ...CHART_INITIAL_STATE.series[2] };

/**
 * Component for show the graphic on the bot message by channel report
 *
 * @param {*} props
 * @returns
 */
const AttendanceTimeGraphic = (props) => {
  const {
    match,
    user,
    botAttendanceTimeGraphic,
    getBotAttendanceTimeGraphic,
    componentData,
    getRefGraphic,
    isCheck,
    bot,
  } = props;

  const { parentFilter, draggableId, onRemoveClick, isEditMode } =
    componentData;

  const { botid } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;

  /** Object for configuration the Highcharts graphic */
  const [chartOptions, setChartOptions] = useState(CHART_INITIAL_STATE);
  const [timezone, setTimezone] = useState('');
  const refChartContainer = useRef(null);

  useEffect(() => {
    getRefGraphic(refChartContainer);
  });

  /**
   * Called for fetch new data for this component
   */

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  }, [bot]);

  useEffect(() => {
    if (user && timezone !== '') {
      const { nameTags, channels, variables } = parentFilter;
      getBotAttendanceTimeGraphic(botid, token, {
        startDate,
        endDate,
        tags: nameTags,
        channels,
        variables,
        timezone,
      });
    }
  }, [parentFilter, user, timezone]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    updateChart();
  }, [botAttendanceTimeGraphic, isCheck]);

  /**
   * Update chart when some information change
   */
  const updateChart = () => {
    const difference = moment.duration(
      moment(endDate.toString()).diff(moment(startDate.toString()))
    );
    const period = getFilterPeriodType(difference);
    const series = updateChartSeries(period);
    const categories = updateChartXCategories(
      period,
      _.pickBy(botAttendanceTimeGraphic, _.identity)
    );

    const chart = {
      ...chartOptions,
      series,
      xAxis: {
        categories,
      },
    };

    setChartOptions(chart);
  };

  /**
   * Update the series property from the chart options object
   * @param {string} period
   */
  const updateChartSeries = (period) => {
    const series = [];
    const newSeries = [...chartOptions.series];

    if (!isCheck) {
      const seriesHuman = newSeries.findIndex(
        (element) => element.serieType === 'human'
      );
      if (seriesHuman !== -1) {
        newSeries.splice(seriesHuman, 1);
      }

      const seriesQueue = newSeries.findIndex(
        (element) => element.serieType === 'queue'
      );
      if (seriesQueue !== -1) {
        newSeries.splice(seriesQueue, 1);
      }
    } else {
      const foundHuman = newSeries.find((serie) => serie.name === 'Humano');
      if (!foundHuman) {
        newSeries.push(seriesHuman);
      }

      const foundQueue = newSeries.find((serie) => serie.name === 'Fila');
      if (!foundQueue) {
        newSeries.push(seriesQueue);
      }
    }

    _.forEach(newSeries, (element) => {
      const newElement = _.cloneDeep(element);
      newElement.data = _.map(
        getCurrentGraphicData(newElement.serieType, period),
        newElement.serieType
      );
      series.push(newElement);
    });
    return series;
  };

  /**
   * Get the channel data array
   * @param {string} channel
   */

  const getChannelMessages = (channel) => {
    return _.map(botAttendanceTimeGraphic, (element) => {
      return { _id: element._id, [channel]: element[channel] };
    });
  };

  /**
   * Get the current graphic data for the array iterator
   * @param {string} type
   * @param {string} period
   */
  const getCurrentGraphicData = (type, period) => {
    switch (type) {
      case 'bot':
        return getTotalGraphic(getChannelMessages(type), period);
      case 'human':
        return getTotalGraphic(getChannelMessages(type), period);
      case 'queue':
        return getTotalGraphic(getChannelMessages(type), period);
      default:
        return [];
    }
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <HighchartsReact
        ref={refChartContainer}
        highcharts={Highcharts}
        options={chartOptions}
        allowChartUpdate
      />
    );
  };

  return (
    <ContainerReport
      type="graphic"
      icon={iconData}
      title="Tempo de atendimento (média)"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
  filter: state.filter,
  botAttendanceTimeGraphic: state.reports.botAttendanceTimeGraphic,
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getBotAttendanceTimeGraphic }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AttendanceTimeGraphic)
);
